import styled from 'styled-components';
import { media } from '../../../helpers/breakpoints';

export const Panel = styled.div`
  padding: ${({ theme }) => `${theme.spacing.M24} ${theme.spacing.M16}`};
  background: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};

  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M24};
  }
`;
